import React, { useState } from "react";

import { Row, Radio, DatePicker, Collapse, Button } from "antd";
import moment from "moment";

const { Panel } = Collapse;

const ReportDateSearchComponent = ({
	searchOptions,
	setSearchOptions,
	updateDate,
	handleSearch,
	handleCancelBtnClick,
}) => {
	const [dateType, setDateType] = useState("today");
	const [isCollapse, setIsCollapse] = useState(["1"]);

	const dateTypeItems = [
		{ label: "이번달", value: "thisMonth" },
		{ label: "오늘", value: "today" },
		// {label: "어제", value: "yesterday"},
		{ label: "1주일", value: "1week" },
		{ label: "1개월", value: "1month" },
		{ label: "3개월", value: "3month" },
		{ label: "6개월", value: "6month" },
	];

	// const handleCollapseChange = (key) => {
	//     setIsCollapse(key)
	// }

	/**
	 * handle dateType change
	 */
	const handleDateTypeChange = (e) => {
		const value = e.target.value;
		setDateType(value);
		switch (value) {
			case "thisMonth":
				setSearchOptions({
					...searchOptions,
					startDate: moment().startOf("month"),
					endDate: moment().endOf("day"),
				});
				break;
			case "today":
				setSearchOptions({
					...searchOptions,
					startDate: moment().startOf("day"),
					endDate: moment().endOf("day"),
				});
				break;
			// case "yesterday":
			//     setSearchOptions({
			//         ...searchOptions,
			//         startDate: moment().subtract(1, 'days').startOf('day'),
			//         endDate: moment().endOf("day")
			//     })
			//     break;
			case "1week":
				if (searchOptions.endDate === null || searchOptions.endDate === "") {
					setSearchOptions({
						...searchOptions,
						startDate: moment().subtract(7, "days").startOf("day"),
						endDate: moment().endOf("day"),
					});
				} else {
					setSearchOptions({
						...searchOptions,
						startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
							.subtract(7, "days")
							.startOf("day"),
					});
				}
				break;
			case "1month":
				if (searchOptions.endDate === null || searchOptions.endDate === "") {
					setSearchOptions({
						...searchOptions,
						startDate: moment().subtract(1, "months").startOf("day"),
						endDate: moment().endOf("day"),
					});
				} else {
					setSearchOptions({
						...searchOptions,
						startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
							.subtract(1, "months")
							.startOf("day"),
					});
				}
				break;
			case "3month":
				if (searchOptions.endDate === null || searchOptions.endDate === "") {
					setSearchOptions({
						...searchOptions,
						startDate: moment().subtract(3, "months").startOf("day"),
						endDate: moment().endOf("day"),
					});
				} else {
					setSearchOptions({
						...searchOptions,
						startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
							.subtract(3, "months")
							.startOf("day"),
					});
				}
				break;
			case "6month":
				if (searchOptions.endDate === null || searchOptions.endDate === "") {
					setSearchOptions({
						...searchOptions,
						startDate: moment().subtract(6, "months").startOf("day"),
						endDate: moment().endOf("day"),
					});
				} else {
					setSearchOptions({
						...searchOptions,
						startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
							.subtract(6, "months")
							.startOf("day"),
					});
				}
				break;
		}
	};

	return (
		<Collapse
			className="report-date-search-wrap"
			// expandIconPosition="right"
			expandIcon={() => <></>}
			// activeKey={isCollapse}
			activeKey={["1"]}
			// onChange={handleCollapseChange}
			// expandIcon={({isActive}) => <img
			//     src={`${process.env.REACT_APP_HOST}/assets/images/report/report-search-date-icon-${isActive ? "up" : "down"}.png`}
			//     className="report-date-search-icon noselect"/>}
			defaultActiveKey={["1"]}
			ghost
		>
			<Panel
				key="1"
				// header={<Row className="report-date-search-title-wrap" wrap={false} justify="space-between"
				//              align="middle">
				//     <div className="report-date-search-recent-date">최근 업데이트 : {updateDate.format("YYYY.MM.DD")}</div>
				//     {searchOptions.startDate || searchOptions.endDate ?
				//         <div className="report-date-search-date-label">날짜 범위 : <span
				//             className="report-date-search-date">{searchOptions.startDate && searchOptions.startDate.format("YYYY.MM.DD")} ~ {searchOptions.endDate && searchOptions.endDate.format("YYYY.MM.DD")}</span>
				//         </div>
				//         : null
				//     }
				// </Row>}
				// header={() => <></>}
			>
				<div className="report-date-search-content-wrap">
					<Row justify="center" align="middle" gutter={[0, 16]}>
						<Radio.Group
							className="report-date-search-select-type-wrap"
							options={dateTypeItems}
							onChange={handleDateTypeChange}
							value={dateType}
							optionType="button"
						/>
						<div>
							<DatePicker
								className="report-search-date-wrap"
								format="YYYY/MM/DD"
								value={searchOptions.startDate}
								onChange={(value) => {
									setDateType("");
									setSearchOptions({ ...searchOptions, startDate: value });
								}}
								allowClear={false}
							/>
							~
							<DatePicker
								className="report-search-date-wrap"
								format="YYYY/MM/DD"
								value={searchOptions.endDate}
								onChange={(value) => {
									setDateType("");
									setSearchOptions({ ...searchOptions, endDate: value });
								}}
								style={{ marginRight: 2 }}
								allowClear={false}
							/>
						</div>
					</Row>
					<Row className="report-date-search-button-wrap" justify="center">
						<Button
							className="report-date-search-button confirm"
							onClick={() => {
								const result = handleSearch();
								if (result) {
									setIsCollapse([]);
								}
							}}
						>
							확인
						</Button>
						<Button
							className="report-date-search-button cancel"
							onClick={() => {
								setDateType(dateTypeItems[1].value);
								handleCancelBtnClick();
								setIsCollapse([]);
							}}
						>
							취소
						</Button>
					</Row>
				</div>
			</Panel>
		</Collapse>
	);
};

export default ReportDateSearchComponent;
